import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../elements/button';

interface Props {
  onAction: () => void;
}

function NotSure({ onAction }: Props) {
  const { t } = useTranslation();
  return (
    <Button className="option-select__not-sure__button text-medium--bold" onClick={onAction}>
      {t('notSure')}
    </Button>
  );
}

export default NotSure;
